import React, { useEffect, useState } from 'react'
import { View, StyleSheet, Text } from 'react-native'

import client  from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import { updateNotifications, testID } from '@sart/utilities'

export default function NotificationProvisioning(props) {
	const { navigation, route } = props

	useEffect(() => {
    checkOrderStatus()
  }, [])
	
	const notification = route.params?.notification
	const basketRefId = route.params?.basketRefId
	

	const content = useContent()

	async function checkOrderStatus() {
		try {
			const order = await client.getOrders(basketRefId)
			if(order?.status === 'successful') {
				var navParams = {
					notification,
					basketRefId
				}
				client.loadBalancesAndInvoices(client.cache.accounts[0])
				navigation.navigate('NotificationConfirmation', navParams)
			} else {
				var navParams = {
					errorMessage:content.errors.notificationProvisioningFailed
				}
				navigation.navigate('NotificationError',navParams)
			}
		} catch (error) {
			// We need to check what the error is and then send it through to the error screen
			var navParams = {
				errorMessage:content.errors.notificationProvisioningTimeout
			}
			navigation.navigate('NotificationError',navParams)
		}
	}

	return (
		<View style={styles.container}>
			<View style={styles.internal}>
				<Text style={styles.text}>{content.notificationProvisioning.notificationProvisioningMessage}</Text>
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
		backgroundColor:colors.white,
		alignItems:"center",
    ...adaptive.wrapperPadding
  },
	internal: {
		flex:1,
		justifyContent:'center',
		
	},
	text: {
		marginHorizontal:44,
		color:colors.feature,
		fontSize:16,
		lineHeight: 24,
		textAlign:'center',
		...typography.bold
	}
})